export const isMaterialColor = ({ color }) => {
  return (
    color === 'primary' ||
    color === 'secondary' ||
    color === 'default' ||
    color === 'inherit'
  );
};

export default {
  isMaterialColor,
};
